import { Button, Layout } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
import SidebarBashIcon from "../../../assets/icons/SidebarBashIcon";
import ThemeSwitcher from "../../../ThemeSwitcher/ThemeSwitcher";
import NotificationMenu from "./NotificationMenu";
import ProfileMenu from "./ProfileMenu";

type Props = {
  collapsed: boolean;
  handleCollapsed: () => void;
  handleShowSidebar: () => void;
};

export default function SidebarContent({
  handleShowSidebar,
  collapsed,
  handleCollapsed,
}: Props) {
  return (
    <Layout className="site-layout transition-all">
      <Header
        style={{
          padding: 0,
          position: "sticky",
          top: 0,
          zIndex: 999,
          height: 80,
        }}
        className="dark:bg-header bg-white"
      >
        <div className="flex items-center max-h-full justify-between pr-5">
          <div className="w-16 h-[80px] flex justify-center items-center">
            <Button
              type="text"
              icon={<SidebarBashIcon />}
              onClick={handleShowSidebar}
              className="lg:hidden flex justify-center items-center"
              size="large"
            />
            <Button
              type="text"
              icon={<SidebarBashIcon />}
              onClick={handleCollapsed}
              className="hidden lg:flex justify-center items-center"
              size="large"
            />
          </div>

          <div className="flex items-center gap-8">
            {/* <ThemeSwitcher />
            <NotificationMenu /> */}
            <ProfileMenu />
          </div>
        </div>
      </Header>

      <Content
        style={{
          padding: 24,
          minHeight: 280,
        }}
        className="text-header dark:bg-[#1c222b] bg-white"
      >
        <Outlet />
      </Content>
    </Layout>
  );
}
